// extracted by mini-css-extract-plugin
module.exports = {"loader":"TermsOfServicePage_loader__3tDX-","heading":"TermsOfServicePage_heading__fzPg1","content":"TermsOfServicePage_content__3MqP9"};